const overrideBack = (callback: () => boolean) => {
  window.history.pushState(null, window.location.href);
  window.onpopstate = () => callback();
};

export default overrideBack;
